export default "__VITE_PUBLIC_ASSET__f9e19b08__"